class HpShopTheLook extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const mobile = window.matchMedia('(max-width: 699px)');
    const looks = this.querySelector('[data-stl-looks]');
    const slides = Array.from(this.querySelectorAll('[data-stl-look]'));
    const modals = Array.from(this.querySelectorAll('x-modal'));
    let activeLook = 0;
    const nearestIndex = (track, items) => items.reduce((nearest, item, index) => {
      const distance = Math.abs(item.getBoundingClientRect().left - track.getBoundingClientRect().left);
      return distance < nearest.distance ? { index, distance } : nearest;
    }, { index: 0, distance: Infinity }).index;
    const scrollToItem = (track, item) => {
      if (!track || !item) return;
      track.scrollBy({ left: item.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    const selectLook = index => {
      if (!slides.length) return;
      activeLook = (index + slides.length) % slides.length;
      this.querySelector('[data-stl-discover]')?.setAttribute('aria-controls', slides[activeLook].dataset.stlLook);
      slides.forEach((slide, slideIndex) => { slide.inert = !mobile.matches && slideIndex !== activeLook; });
    };
    looks?.addEventListener('scroll', () => selectLook(nearestIndex(looks, slides)), { ...options, passive: true });
    this.addEventListener('click', event => {
      const trigger = event.target.closest('[data-stl-look-trigger]');
      if (trigger) {
        this.querySelector('[data-stl-discover]')?.setAttribute('aria-controls', trigger.getAttribute('aria-controls'));
        if (!mobile.matches) event.stopPropagation();
      }
      const step = event.target.closest('[data-stl-look-step]');
      if (step) {
        selectLook(activeLook + Number(step.dataset.stlLookStep));
        scrollToItem(looks, slides[activeLook]);
      }
    }, options);
    this.querySelectorAll('.hp-stl-products-panel').forEach(panel => {
      const track = panel.querySelector('[data-stl-products]');
      const products = Array.from(track.children);
      let activeProduct = 0;
      const update = index => {
        activeProduct = (index + products.length) % products.length;
        const counter = panel.querySelector('[data-stl-product-counter]');
        if (counter) counter.textContent = `${activeProduct + 1} / ${products.length}`;
        panel.querySelectorAll('[data-stl-product-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.stlProductIndex) === activeProduct)));
      };
      track.addEventListener('scroll', () => update(nearestIndex(track, products)), { ...options, passive: true });
      panel.addEventListener('click', event => {
        const step = event.target.closest('[data-stl-product-step]');
        const dot = event.target.closest('[data-stl-product-index]');
        if (!step && !dot) return;
        update(dot ? Number(dot.dataset.stlProductIndex) : activeProduct + Number(step.dataset.stlProductStep));
        scrollToItem(track, products[activeProduct]);
      }, options);
    });
    const resize = () => {
      selectLook(activeLook);
      if (looks && slides[activeLook]) looks.scrollLeft += slides[activeLook].getBoundingClientRect().left - looks.getBoundingClientRect().left;
      if (!mobile.matches) modals.forEach(modal => { if (modal.hasAttribute('open')) modal.hide(); });
    };
    mobile.addEventListener?.('change', resize, options);
    selectLook(0);
    modals.forEach(modal => {
      let gesture = null;
      modal.addEventListener('touchstart', event => {
        gesture = null;
        if (!window.matchMedia('(max-width: 699px)').matches || event.touches.length !== 1) return;
        if (event.target.closest('a, button, input, select, textarea')) return;
        const content = modal.shadowRoot?.querySelector('[part="content"]');
        const canDismiss = event.target.closest('.hp-stl-swipe-handle') || !content || content.scrollHeight <= content.clientHeight + content.scrollTop + 1;
        if (!canDismiss) return;
        gesture = { x: event.touches[0].clientX, y: event.touches[0].clientY, time: Date.now() };
      }, { ...options, passive: true });
      modal.addEventListener('touchcancel', () => { gesture = null; }, options);
      modal.addEventListener('touchend', event => {
        const start = gesture;
        gesture = null;
        if (!start || !event.changedTouches.length || event.touches.length) return;
        const deltaX = event.changedTouches[0].clientX - start.x;
        const deltaY = event.changedTouches[0].clientY - start.y;
        if (deltaY < -60 && Math.abs(deltaY) > Math.abs(deltaX) * 1.4 && Date.now() - start.time < 700) {
          event.preventDefault();
          modal.hide();
        }
      }, { ...options, passive: false });
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}

if (!customElements.get('hp-shop-the-look')) customElements.define('hp-shop-the-look', HpShopTheLook);
